import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {AutoplayHandlerModule} from '@fantasmagames/slot/src/modules/autoplay/AutoplayHandlerModule';
import {AutoplayMenuEvents} from '@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/AutoplayMenuEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';

export class AutoplayBasicState extends ModuleState<null, AutoplayHandlerModule> {
	public onEnterState(): void {}

	public onLeaveState(): void {}

	protected setupEvents(): void {
		this.on(AutoplayMenuEvents.ACCEPTED, this.onAutoPlaySettingsAccepted);
		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);
	}

	protected onCanSpin(): void {
		this.module.setCanSpin(true);
	}

	protected onAutoPlaySettingsAccepted(eventID: string, spinsLeft: number): void {
		this.module.logic.lastAutoplayAmount = spinsLeft;
		this.module.startAutoplay(spinsLeft);
		this.module.gotoState(AutoplayHandlerModule.IN_PROGRESS);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/autoplay/states/AutoplayBasicState.ts